import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Auto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render() {
    const faqs = [
      { q: "❓ Это действительно бесплатно для автосервиса?", a: "Да. Никакой абонентской платы, процентов с броней. Оплата только за SMS (если подключите) и комиссия банка за онлайн-оплату. Бесплатно навсегда." },
      { q: "❓ Как клиенты могут записаться?", a: "Онлайн через вашу страницу с QR-кодом (разместите на стойке) или по телефону – вы вносите бронь вручную. Всё в едином календаре." },
      { q: "❓ Могу ли я настроить разные услуги и цены?", a: "Да. Шиномонтаж, замена масла, диагностика, мойка – разные цены, длительность, мастера." },
      { q: "❓ Как работает подписка на освобождение слота?", a: "Если время занято, клиент оставляет контакт. При отмене – уведомление, он бронирует первым." },
      { q: "❓ Нужно ли клиентам приложение?", a: "Нет, достаточно браузера. Есть нативные приложения для iOS и Android." }
    ];

    return (
      <div class="fa-container">
        <Helmet>
          <title>Онлайн-запись для автосервиса и шиномонтажа | Бесплатная CRM — Planna</title>
          <meta name="description" content="Автоматизируйте запись клиентов на ремонт, шиномонтаж, мойку. Календарь мастеров, подъёмников, напоминания. Бесплатно навсегда." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>

        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">🔧 Для автосервисов, шиномонтажа, автомоек | Бесплатно навсегда</div>
            <h1>Онлайн-запись <span className="highlight">для автосервиса и шиномонтажа</span></h1>
            <p className="hero-description">Клиенты сами записываются на удобное время 24/7. Управляйте загрузкой мастеров, подъёмников, автомоек. Автоматические напоминания, аналитика, единый календарь. Всё бесплатно.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить автосервис бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Преимущества */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Всё для управления вашим автосервисом</h2>
              <p className="section-subtitle">Принимайте заказы онлайн и по телефону, заполняйте боксы на 100%</p>
            </div>
            <div className="grid-3 fade-up">
              <div className="benefit-card"><i className="fas fa-calendar-alt benefit-icon"></i><h3>Онлайн-запись 24/7</h3><p>Клиенты выбирают дату, время, услугу и мастера. QR-код для стоек ресепшн.</p></div>
              <div className="benefit-card"><i className="fas fa-phone-alt benefit-icon"></i><h3>Запись по телефону – тоже в системе</h3><p>Администратор вносит заявки вручную за 10 секунд. Всё в едином календаре.</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>Аналитика загрузки</h3><p>Занятость мастеров, подъёмников, популярные услуги – полный контроль.</p></div>
              <div className="benefit-card"><i className="fas fa-bell benefit-icon"></i><h3>Автоматические напоминания</h3><p>SMS, Telegram, push – снижение неявок на 70%.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>QR-код для клиентов</h3><p>Разместите на стойке, в зоне ожидания – запись в 2 клика.</p></div>
              <div className="benefit-card"><i className="fas fa-hand-holding-usd benefit-icon"></i><h3>Дополнительные услуги</h3><p>Клиент может добавить мойку, шиномонтаж, диагностику – увеличивайте чек.</p></div>
            </div>
          </div>
        </section>

        {/* Скриншоты (замените src) */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Как это работает</h2>
              <p className="section-subtitle">Простой интерфейс для вас и ваших клиентов</p>
            </div>
            <div className="grid-2 fade-up" style={{ gap: '2.5rem' }}>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Календарь+записи+автосервиса" alt="Календарь записи" />
                <div className="mockup-label">📅 Выбор времени и услуги</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=QR-код+для+клиентов" alt="QR-код" />
                <div className="mockup-label">📱 QR-код на стойке</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Напоминание+клиенту" alt="Напоминание" />
                <div className="mockup-label">🔔 Напоминание о визите</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Единый+календарь+мастеров" alt="Календарь мастеров" />
                <div className="mockup-label">🔄 Загрузка мастеров и подъёмников</div>
              </div>
            </div>
          </div>
        </section>

        {/* Умные функции */}
        <section>
          <div className="container">
            {/* Подписка на освободившиеся слоты */}
            <div className="smart-block fade-up" style={{ marginTop: 0 }}>
              <div style={{ flex: 1 }}>
                <i className="fas fa-bell" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Подписка на освободившиеся слоты</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Все боксы заняты? Клиент подписывается на уведомление. Как только кто-то отменяет запись – мгновенное оповещение, клиент бронирует первым.</p>
                <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Максимальная заполняемость</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Ни одного потерянного заказа</li></ul>
              </div>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/500x300/F9FAFB/32bea6?text=Подписка+на+слот" alt="Подписка" /><div className="mockup-label">🔔 Клиент подписывается – вы заполняете слот</div></div></div>
            </div>

            {/* Календарь загрузки на месяц */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-chart-line" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Календарь загрузки на месяц</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит цветовую индикацию занятости: зелёные дни – свободно, красные – пик. Выбирает спокойное время для посещения.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Равномерное распределение клиентов</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобно для клиентов</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="{{mainApiUrl}}calendar1.png" alt="Календарь загрузки" /><div className="mockup-label">📅 Зелёный – свободно, красный – пик</div></div></div>
            </div>

            {/* Единый календарь сотрудников */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-calendar-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Единое пространство для сотрудников</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Календарь каждого мастера интегрируется с его личными делами. Записался к врачу? Это время автоматически блокируется. Никаких конфликтов, никаких двойных броней.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Автоматическое избежание накладок</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Прозрачность для администратора</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Единый+календарь" alt="Единый календарь" /><div className="mockup-label">🔄 Личное + рабочее – вместе</div></div></div>
            </div>

            {/* Два календаря при бронировании */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
                <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Два+календаря" alt="Два календаря" /><div className="mockup-label">📅 Два календаря – один выбор</div></div></div>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>При бронировании – два календаря рядом</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит свои личные события из Google и Apple календаря (только в приложении) и свободные слоты сервиса. Выбирает только время, которое подходит ему.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Без конфликтов с личными планами</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобный выбор времени</li></ul>
                </div>
            </div>
          </div>
        </section>

        {/* Типы автоуслуг */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Подходит для любых автоуслуг</h2>
            <div className="stats-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-wrench"></i><h3>Автосервис</h3><p>Ремонт, диагностика, ТО</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-car"></i><h3>Шиномонтаж</h3><p>Сезонная смена шин</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-tint"></i><h3>Автомойка</h3><p>Мойка кузова, химчистка</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-spray-can"></i><h3>Детейлинг</h3><p>Полировка, защита покрытия</p></div>
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white' }}>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="{{mainApiUrl}}mobile1.png" alt="Мобильное приложение" /><div className="mockup-label">📱 Управляйте автосервисом со смартфона</div></div></div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p>Ваши сотрудники и клиенты могут пользоваться сервисом через нативные приложения для iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для автосервиса:</strong> управление бронями, расписанием, уведомления</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для клиентов:</strong> запись, отмена, напоминания, история</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: '45px' }} /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png" alt="Google Play" style={{ height: '45px' }} /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Частые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>
                    {faq.q} <i className="fas fa-chevron-down"></i>
                  </div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Начните принимать онлайн-запись уже сегодня</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Больше никаких бумажных журналов и потерянных клиентов. Ваши боксы будут заполнены.</p>
            <a href="/authentication/register" className="btn-filled btn-white">Зарегистрироваться <i className="fas fa-arrow-right"></i></a>
            <a href="/configcompany" className="btn-filled btn-white">Подключить бизнес бесплатно <i className="fas fa-arrow-right"></i></a>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>Настройка за 15 минут. QR-код, напоминания, аналитика — 0₽</p>
          </div>
        </section>
      </div>
    );
  }
}
